/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { D as Dropdown, d as defineCustomElement$1 } from './dropdown.js';

const CalciteDropdown = Dropdown;
const defineCustomElement = defineCustomElement$1;

export { CalciteDropdown, defineCustomElement };

//# sourceMappingURL=calcite-dropdown.js.map